const baseUrl = process.env.NODE_ENV === 'development'
    ? 'http://localhost/propiedades'
    : 'https://inmobiliariapercara.com/back';

const API = {
    read: `${baseUrl}/api/read.php`,
    readimg: `${baseUrl}/upload`,
    create: `${baseUrl}/api/create.php`,
    delete: `${baseUrl}/api/delete.php`,
    update: `${baseUrl}/api/update.php`,
};

export default API;
